import { styled, Button } from '@mui/material';

export const LanguageSelectorButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: theme.spacing(0.75),
  padding: theme.spacing(0.75, 1.5),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '6px',
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
  textTransform: 'none',
  minWidth: '155px',
  width: '155px',
  height: '36px',
  transition: 'all 0.2s ease-in-out',

  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.action.active,
  },
}));

export const LanguageIcon = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.action.active,

  '& svg': {
    fontSize: '18px',
  },
}));

export const LanguageText = styled('span')(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 400,
  lineHeight: 1,
  color: theme.palette.text.primary,
}));
